module.exports = __webpack_public_path__ + "assets/img/404_forum.453f5362.svg";